import { ResponseModel } from '../../../shared/models/reponse.model';
import { TopconConfigurationResponseDto } from '../dtos/partner-configuration.dto';
import { TestActivationConfig } from '../dtos/test-activation-config.dto';
import { PartnerModel } from './partner.model';
import { SavedServiceLevelConfigurationModel } from './service-level-configuration.model';

export class TopconConfigurationResponseModel extends ResponseModel {
    private _configuration: TopconConfigurationResponseDto;

    public constructor(configuration: TopconConfigurationResponseDto) {
        super(configuration);
        this._configuration = configuration;
    }

    public getPartnerModel(): PartnerModel {
        return new PartnerModel(this._configuration.serviceLevelConfiguration.partner);
    }

    public getServiceLevelConfiguration(): SavedServiceLevelConfigurationModel[] {
        return this._configuration.serviceLevelConfiguration.configurations?.map(config => new SavedServiceLevelConfigurationModel(config)) ?? [];
    }

    public getTestActivationConfigs(): TestActivationConfig[] {
        return [...this._configuration.serviceLevelConfiguration.testActivationConfigs ?? []];
    }
}
